module.exports = __webpack_public_path__ + "static/media/connect-line.157fb71b.svg";